import React from 'react'
import { ConfigProvider, Steps } from 'antd'

const CommonStepper = ({ items }) => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '##D9D9D9',
          borderRadius: 2,
          colorBgContainer: '#f6ffed',
          dotSize: 20
        }
      }}
    >
      <Steps progressDot direction="vertical" labelPlacement="horizontal" descriptionMaxWidth={160} current={1} dotSize={20} items={items} />
    </ConfigProvider>
  )
}
export default CommonStepper
